const pageNumberRegex = /\/(\d+)\/$/;
export default pageNumberRegex;
